import React, { FC } from 'react';
import { RouteComponentProps } from '@reach/router';
import cx from 'clsx';
import { useTranslation } from 'react-i18next';

import { ReactComponent as Detective } from './images/detective.svg';
import { PageLayout } from 'components/PageLayout';

import styles from './styles.module.scss';

const PageNotFound: FC<RouteComponentProps> = () => {
  const { t } = useTranslation();

  return (
    <PageLayout>
      <div className={styles.notFoundWrapper}>
        <Detective className={styles.notFoundLogo} aria-hidden={true} />
        <h1>{t('oops')}</h1>
        <p>{t('notFound')}</p>
        <a href="https://www.clover.com" className={cx(styles.button)}>
          {t('home')}
        </a>
      </div>
    </PageLayout>
  );
};

export { PageNotFound };
